module.exports = __webpack_public_path__ + "img/AF_GusmãoLabrunie_Icones_digital-law.27bdd310.png";